/**
 * @generated SignedSource<<bf59478679f84bf44b49fd41a2544ee4>>
 * @relayHash 0250f6408e8d8064d7cc97a77e2f5386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery$variables = {
  schemeId: string;
};
export type mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery$data = {
  readonly jira: {
    readonly viewPermissionScheme: {
      readonly configuration?: {
        readonly isEditable: boolean;
      };
      readonly " $fragmentSpreads": FragmentRefs<"PermissionsTable" | "header_permissionScheme">;
    };
  } | null | undefined;
};
export type mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery = {
  response: mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery$data;
  variables: mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "schemeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "schemeId",
    "variableName": "schemeId"
  }
],
v2 = {
  "concreteType": "JiraPermissionSchemeConfiguration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "description"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v6/*: any*/)
],
v9 = [
  (v4/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v1/*: any*/),
              "kind": "LinkedField",
              "name": "viewPermissionScheme",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "header_permissionScheme"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "PermissionsTable"
                    },
                    (v2/*: any*/)
                  ],
                  "type": "JiraPermissionSchemeView"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.viewPermissionScheme"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "viewPermissionScheme",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraPermissionScheme",
                    "kind": "LinkedField",
                    "name": "scheme",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "JiraPermissionSchemeGrantGroup",
                    "kind": "LinkedField",
                    "name": "grantGroups",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectPermissionCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraPermissionGrantHolder",
                        "kind": "LinkedField",
                        "name": "grantHolders",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraProjectPermission",
                            "kind": "LinkedField",
                            "name": "permission",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraPermissionGrants",
                            "kind": "LinkedField",
                            "name": "grants",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraGrantTypeKey",
                                "kind": "LinkedField",
                                "name": "grantType",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v4/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraPermissionGrantValue",
                                "kind": "LinkedField",
                                "name": "grantValues",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "type": "JiraDefaultGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": (v8/*: any*/)
                                          }
                                        ],
                                        "type": "JiraUserGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "concreteType": "JiraGroup",
                                            "kind": "LinkedField",
                                            "name": "group",
                                            "plural": false,
                                            "selections": (v9/*: any*/)
                                          }
                                        ],
                                        "type": "JiraGroupGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "field",
                                            "plural": false,
                                            "selections": (v8/*: any*/)
                                          }
                                        ],
                                        "type": "JiraIssueFieldGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "concreteType": "JiraRole",
                                            "kind": "LinkedField",
                                            "name": "role",
                                            "plural": false,
                                            "selections": (v9/*: any*/)
                                          }
                                        ],
                                        "type": "JiraProjectRoleGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      }
                                    ]
                                  },
                                  (v6/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v2/*: any*/)
                ],
                "type": "JiraPermissionSchemeView"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
    "metadata": {},
    "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "41dd09a71a35c8ed416631b02fa73316";

export default node;
